
// These should be synced with the actual collection names in the Firestore database which are created by the backend.
const kAssetsCollectionName = "assets"
const kTracksCollectionName = "tracks"
const kProjectsCollectionName = "projects"
const kSequencesCollectionName = "sequences"
const kSequenceLayersSubcollectionName = "layers"
const kSequenceLayerClipsSubcollectionName = "clips"
const kCompositionsCollectionName = "compositions"
const kSpeakersCollectionName = "speakers"
const kFoldersCollectionName = "folders"
const kCompositionLayersSubcollectionName = "layers"
const kCompositionLayerClipsSubcollectionName = "clips"
const kLocalRecordingsCollectionName = "localRecordings"
const kTranscriptsCollectionName = "transcripts"
const kLayoutPacksCollectionName = "layoutPacks"
const kEditorStateIdMappingCollectionName = "editorStateIdMapping"
const kEditorStateCollectionName = "editorState"

const WorkspaceId = "workspaceId";

const kEditsCollectionName = "edits"

const kRoomStateCollectionName = "rooms"

const RoomName = "roomName"

const RoomUserId = "userId"

const RoomState = "roomState"

const EditId = "editId";
const EditTrackId = "trackId";
const EditAssetId = "assetId";
const EditTitle = "title";
const EditCreatedAt = "createdAt";

const EditUserId = "userId";

const RoomNotRecording = 0;
const RoomRecordingStarting = 1;
const RoomRecordingInProgress = 2;

const AssetId = "assetId";
const AssetUserId = "userId";
const AssetProjectId = "projectId";
const AssetTitle = "title";
const AssetType = "assetType";
const AssetSource = "source";
const AssetCreateTime = "createTime";
const AssetStatus = "status";
const AssetDeleted = "deleted";

const kLibrettoUserCollectionName = "users"

export const SequenceId = "sequenceId";
export const SequenceUserId = "userId";
export const SequenceProjectId = "projectId";
export const SequenceTitle = "title";
export const SequenceDeleted = "deleted";
export const SequenceCreatedAt = "createdAt";


export const CompositionId = "compositionId";
export const CompositionUserId = "userId";
export const CompositionProjectId = "projectId";
export const CompositionTitle = "title";
export const CompositionDeleted = "deleted";
export const CompositionCreatedAt = "createdAt";

export const SpeakerId = "speakerId";
export const SpeakerUserId = "userId";
export const SpeakerName = "name";
export const SpeakerProjectId = "projectId";

export const FolderId = "folderId";
export const FolderUserId = "userId";
export const FolderName = "name";
export const FolderProjectId = "projectId";
export const FolderDeleted = "deleted";
export const FolderFileIds = "fileIds"; // Array of trackIds/assetIds

const TrackId = "trackId";
const TrackAssetId = "assetId";
const TrackUserId = "userId";
const TrackEgressId = "egressId";
const TrackTitle = "title";
const TrackType = "trackType";
const TrackStatus = "status";
const TrackStorageBucket = "storageBucket";
const TrackObjectName = "objectName";
const TrackResolution = "resolution";
const TrackSampleRate = "sampleRate";
const TrackAudioBitrate = "audioBitrate";
const TrackVideoBitrate = "videoBitrate";
const TrackDuration = "duration";
const TrackDeleted = "deleted";
const TrackProjectId = "projectId";
// Backup track fields (LiveKit backup of local recordings)
const TrackIsBackup = "isBackup";
const TrackIsPlaceholder = "isPlaceholder";
const TrackPrimaryTrackId = "primaryTrackId";
const TrackBackupTrackId = "backupTrackId";
const TrackBackupAvailableAt = "backupAvailableAt";
const TrackBackupPromoted = "backupPromoted";

const ProjectId = "projectId";
const ProjectUserId = "userId";
const ProjectName = "name";
const ProjectCreateTime = "createTime";
const ProjectUpdateTime = "updateTime";
const ProjectDeleted = "deleted";
const LibrettoUserId                = "userId"
const LibrettoUserEmail             = "email"
const LibrettoRoomName              = "roomName"
const LibrettoDisplayName           = "displayName"
const LibrettoUserFriendlyRoomName  = "userFriendlyRoomName"
const LibrettoUserPlan              = "plan"
const LibrettoUserAllowedToLogin    = "allowedToLogin"


const EditorStateAssetId = "assetId";
const EditorStateEditId = "editId";
const EditorStateUserId = "userId";
const EditorStateProjectId = "projectId";
const EditorStateData = "data";

export const EditorStateIdMappingEditId = "editId";
export const EditorStateIdMappingUserId = "userId";
export const EditorStateIdMappingMediaId = "mediaId";
export const EditorStateIdMappingEntityId = "entityId";

export {
    kAssetsCollectionName,
    kTracksCollectionName,
    kSequencesCollectionName,
    kSequenceLayersSubcollectionName,
    kSequenceLayerClipsSubcollectionName,
    kCompositionsCollectionName,
    kSpeakersCollectionName,
    kFoldersCollectionName,
    kCompositionLayersSubcollectionName,
    kCompositionLayerClipsSubcollectionName,
    kRoomStateCollectionName,
    kLocalRecordingsCollectionName,
    kProjectsCollectionName,
    kTranscriptsCollectionName,
    kLayoutPacksCollectionName,
    EditorStateData,
    EditorStateEditId,
    EditorStateUserId,
    EditorStateProjectId,
    AssetId,
    AssetUserId,
    AssetProjectId,
    AssetTitle,
    AssetType,
    AssetSource,
    AssetCreateTime,
    AssetStatus,
    AssetDeleted,
    TrackId,
    TrackAssetId,
    TrackProjectId,
    TrackUserId,
    TrackEgressId,
    TrackTitle,
    TrackStatus,
    TrackStorageBucket,
    TrackObjectName,
    TrackResolution,
    TrackSampleRate,
    TrackAudioBitrate,
    TrackVideoBitrate,
    TrackDuration,
    TrackDeleted,
    ProjectId,
    ProjectUserId,
    ProjectName,
    ProjectCreateTime,
    ProjectUpdateTime,
    ProjectDeleted,
    RoomName,
    RoomState,
    kEditsCollectionName,
    kLibrettoUserCollectionName,
 LibrettoUserId           ,
 LibrettoUserEmail        ,
 LibrettoRoomName           ,
 LibrettoDisplayName         ,
 LibrettoUserFriendlyRoomName ,
 LibrettoUserPlan      ,
 LibrettoUserAllowedToLogin   ,
    RoomNotRecording,
    RoomRecordingStarting,
    RoomRecordingInProgress,
    RoomUserId,
    TrackType,
    EditTitle,
    EditId,
    EditTrackId,
    EditAssetId,
    EditCreatedAt,
    EditUserId,
    EditorStateAssetId,
    kEditorStateIdMappingCollectionName,
    kEditorStateCollectionName,
    TrackIsBackup,
    TrackIsPlaceholder,
    TrackPrimaryTrackId,
    TrackBackupTrackId,
    TrackBackupAvailableAt,
    TrackBackupPromoted,
    WorkspaceId,
};
